module.exports = __webpack_public_path__ + "static/media/g-5-a.f7015f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-5-a.jpg
// module id = 469
// module chunks = 33